const Card = ({ 
  children, 
  className = '', 
  hover = true,
  padding = 'md',
  ...props 
}) => {
  const paddings = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  }

  return (
    <div 
      className={`
        bg-white dark:bg-slate-800 
        border border-slate-200 dark:border-slate-700 
        rounded-2xl 
        shadow-sm
        transition-all duration-300
        ${hover ? 'hover:border-zenna-violet/50 hover:shadow-lg hover:shadow-zenna-violet/5' : ''}
        ${paddings[padding]}
        ${className}
      `}
      {...props}
    >
      {children}
    </div>
  )
}

export const CardHeader = ({ children, className = '' }) => (
  <div className={`mb-4 ${className}`}>
    {children}
  </div>
)

export const CardTitle = ({ children, className = '' }) => (
  <h3 className={`text-xl font-bold text-slate-900 dark:text-white ${className}`}>
    {children}
  </h3>
)

export const CardDescription = ({ children, className = '' }) => (
  <p className={`text-slate-500 dark:text-slate-400 mt-1 ${className}`}>
    {children}
  </p>
)

export const CardContent = ({ children, className = '' }) => (
  <div className={className}>
    {children}
  </div>
)

export const CardFooter = ({ children, className = '' }) => (
  <div className={`mt-4 pt-4 border-t border-slate-100 dark:border-slate-700 ${className}`}>
    {children}
  </div>
)

export default Card
